<div [formGroup]="form">
  <div class="nvb-first-part ms-1">
    <div class="row">
      <div class="col-8">
        <rask-header size="4" noPadding>Naturvärden</rask-header>
      </div>
      <div class="col-2">
        <rask-header size="4" class="right-aligned" noPadding>Antal per ha</rask-header>
      </div>
      <div class="col-2">
        <rask-header size="4" noPadding>Högt naturvärde</rask-header>
      </div>
    </div>

    <div class="nvb-item">
      <rask-header size="4" noPadding>Naturvärdesträd (antal per ha) *</rask-header>
      <div class="row">
        <div class="col-10">
          <div class="row">
            <div class="col-9 align-self-center">
              <div>
                Alla trädslag<br />
                <span class="italic">20 eller fler ger högt naturvärde</span>
              </div>
            </div>
            <div class="col-3 align-self-center">
              <rask-input-number [useDecimalProcessor]="true"
                [isDecimal]="false"
                [isNegative]="false"
                [min]="0"
                placeholder="Antal"
                formControlName="naturvardestradTotalPerHa"
                (ngModelChange)="naturvardeChanged()">
              </rask-input-number>
            </div>
          </div>
          @if (showNaturvardestradTrslPerHa) {
            <div>
              <div class="row nvb-sub-item">
                <div class="col-9 align-self-center">
                  <div class="nvb-sub-item">
                    Enskilt trädslag (ange det med högst antal)<br />
                    <span class="italic">16 eller fler ger högt naturvärde</span>
                  </div>
                </div>
                <div class="col-3 align-self-center">
                  <rask-input-number [useDecimalProcessor]="true" [min]="0" placeholder="Antal"
                    [isDecimal]="false"
                    [isNegative]="false"
                    formControlName="naturvardestradTrslPerHa"
                    (ngModelChange)="naturvardeChanged()">
                  </rask-input-number>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="naturvardestrad"></rask-checkbox>
        </div>
      </div>
      <rask-virkeskop-validation-message
        [messageId]="['naturvardestradTotalPerHa','naturvardestradTrslPerHa']"
        [entityGuid]="atgardGuid$ | async">
      </rask-virkeskop-validation-message>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Naturvärdesträd av hög kvalitet (antal per ha) *
      </rask-header>
      <div class="row">
        <div class="col-8 align-self-center">
          Naturvärdesträd som har mycket tydliga karaktärer, är mycket grova och/eller är mycket gamla<br />
          <span class="italic">10 eller fler ger högt naturvärde</span>
        </div>
        <div class="col-2">
          <rask-input-number [useDecimalProcessor]="true" [min]="0" placeholder="Antal"
            [isDecimal]="false"
            [isNegative]="false"
            formControlName="naturvardestradKvalitetTotalPerHa"
            (ngModelChange)="naturvardeKvalitetChanged()">
          </rask-input-number>
        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="naturvardestradKvalitet"></rask-checkbox>
        </div>
      </div>
      <rask-virkeskop-validation-message
        [messageId]="['naturvardestradKvalitetTotalPerHa']"
        [entityGuid]="atgardGuid$ | async">
      </rask-virkeskop-validation-message>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Död ved (antal per ha) *</rask-header>
      <div class="row">
        <div class="col-10">
          <div class="row">
            <div class="col-9 align-self-center">
              <div>
                Alla trädslag, stående och liggande död ved<br />
                <span class="italic">25 eller fler ger högt naturvärde</span>
              </div>
            </div>
            <div class="col-3 align-self-center">
              <rask-input-number [useDecimalProcessor]="true"
                [isDecimal]="false"
                [isNegative]="false"
                [min]="0"
                placeholder="Antal"
                formControlName="dodVedTotalPerHa"
                (ngModelChange)="dodVedChanged()">
              </rask-input-number>
            </div>
          </div>
          @if (showDetailedDeadWood) {
            <div>
              <div class="row nvb-sub-item">
                <div class="col-9 align-self-center">
                  <div class="nvb-sub-item">
                    Enskilt trädslag, stående och liggande död ved (ange det med högst antal)<br />
                    <span class="italic">20 eller fler ger högt naturvärde</span>
                  </div>
                </div>
                <div class="col-3 align-self-center">
                  <rask-input-number [useDecimalProcessor]="true"
                    [isDecimal]="false"
                    [isNegative]="false"
                    [min]="0"
                    placeholder="Antal"
                    formControlName="dodVedTrslPerHa"
                    (ngModelChange)="dodVedChanged()">
                  </rask-input-number>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="dodVed"></rask-checkbox>
        </div>
      </div>
      <rask-virkeskop-validation-message
        [messageId]="['dodVedTrslPerHa', 'dodVedTotalPerHa']"
        [entityGuid]="atgardGuid$ | async">
      </rask-virkeskop-validation-message>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Död ved av hög kvalitet (antal per ha) *</rask-header>
      <div class="row">
        <div class="col-8 align-self-center">
          Stående och liggande död ved av hög kvalitet<br />
          <span class="italic">11 eller fler ger högt naturvärde</span>
        </div>
        <div class="col-2">
          <rask-input-number [useDecimalProcessor]="true" [min]="0" placeholder="Antal"
            [isDecimal]="false"
            [isNegative]="false"
            formControlName="dodVedKvalitetTotalPerHa"
            (ngModelChange)="dodVedQualityChanged()">
          </rask-input-number>
        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="dodVedKvalitet"></rask-checkbox>
        </div>
      </div>
      <rask-virkeskop-validation-message
        [messageId]="['dodVedKvalitetTotalPerHa']"
        [entityGuid]="atgardGuid$ | async">
      </rask-virkeskop-validation-message>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Ålder</rask-header>
      <div class="row ">
        <div class="col-8 align-self-center">
          Trädskikt med en snittålder på minst 160 år
        </div>
        <div class="col-2">

        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="alder"></rask-checkbox>
        </div>
      </div>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Kontinuitet</rask-header>
      <div class="row">
        <div class="col-8 align-self-center">
          Tydlig beståndskontinuitet (t ex kontinuitet i träd, stor variation i död ved, olikåldrig, flera
          trädskikt)
        </div>
        <div class="col-2">

        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="kontinuitet"></rask-checkbox>
        </div>
      </div>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Trädslag</rask-header>
      <div class="row">
        <div class="col-8 align-self-center">
          Mer än 40% av trädslagsblandningen utgörs av bristträdslag (i skog över LÅF)
        </div>
        <div class="col-2">

        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="tradslag"></rask-checkbox>
        </div>
      </div>
    </div>
    <div class="nvb-item">
      <rask-header size="4" noPadding>Hänsynskrävande biotop</rask-header>
      <div class="row">
        <div class="col-8 align-self-center">
          Större hänsynskrävande biotop som täcker största delen av åtgärden
          <rask-icon popoverTriggers="raskDefault" icon="fas fa-info-circle">
            <a href="https://www.skogsstyrelsen.se/mer-om-skog/malbilder-for-god-miljohansyn/"
            target="_blank">Målbilder för god miljöhänsyn</a>
          </rask-icon>
        </div>
        <div class="col-2">

        </div>
        <div class="col-2 align-self-center">
          <rask-checkbox text="Ja" formControlName="hansynskravandeBiotop"></rask-checkbox>
        </div>
      </div>
    </div>
  </div>
  @if (!isSummed) {
    <div class="row py-3">
      <div class="col text-end">
        <rask-button color="secondary" (click)="aggregateValues()" [disabled]="!canAggregate() || readonly">Summera
          naturvärden
        </rask-button>
      </div>
    </div>
  }
  @if (showSecondForm) {
    <div class="nvb-second-part ms-1">
      @if (isSummed) {
        <div class="row py-3">
          <div class="col">
            <rask-message-panel
              [numberOfItemsToDisplay]="1"
              [maxNumOfRows]="1"
              [labels]="[{'severity':4, 'labelText': 'Summering Naturvärden'}]"
              [items]="sumItems">
            </rask-message-panel>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-10">
          <rask-header size="4" noPadding>Övriga värden</rask-header>
        </div>
        <div class="col-2">
        </div>
      </div>
      <div class="nvb-item">
        <div class="row">
          <div class="col-10 align-self-center">
            Känd förekomst av naturvårdsarter
            <rask-icon popoverTriggers="raskDefault" icon="fas fa-info-circle">
              T ex rödlistade arter, arter listade enligt artskyddsförordningen, fridlysta arter,
              åtgärdsprogramsarter eller signalarter. Hittas på
              <a href="https://kartor.skogsstyrelsen.se/kartor/" target="_blank">skogsstyrelsens karttjänst
              för skogens pärlor</a>
            </rask-icon>
          </div>
          <div class="col-2 align-self-center">
            <rask-checkbox text="Ja" formControlName="kandForekomstNaturvardesarter"></rask-checkbox>
          </div>
        </div>
      </div>
      <div class="nvb-item">
        <div class="row ">
          <div class="col-10 align-self-center">
            Känd förekomst av forn- eller kulturlämningar, där förstärkt hänsyn krävs
          </div>
          <div class="col-2 align-self-center">
            <rask-checkbox text="Ja" formControlName="kandForekomstFornKulturlamn"></rask-checkbox>
          </div>
        </div>
      </div>
      <div class="nvb-item">
        <div class="row">
          <div class="col-10 align-self-center">
            Skog som enligt målbilderna är värdefull för friluftsliv och rekreation och där samverkan krävs
            (information/dialog/samråd)
            <rask-icon popoverTriggers="raskDefault" icon="fas fa-info-circle">
              <a href="https://www.skogsstyrelsen.se/mer-om-skog/malbilder-for-god-miljohansyn/"
              target="_blank">Målbilder för god miljöhänsyn</a>
            </rask-icon>
          </div>
          <div class="col-2 align-self-center">
            <rask-checkbox text="Ja" formControlName="skogVardefullFriluftsklivRekreation"></rask-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <rask-header size="4" noPadding>Hänsyn till miljövärden tas genom</rask-header>
        </div>
      </div>
      <div class="row">
        <div class="col ps-0">
          <rask-radiobutton-group [verticalLayout]="true" label="Välj ett alternativ *"
            formControlName="hansynMiljovarden"
            [buttons]="[{ key: 'Generell miljöhänsyn', value: 'Generell miljöhänsyn (PG)' }, { key: 'Förstärkt miljöhänsyn', value: 'Förstärkt miljöhänsyn (PF)' }, { key: 'Naturvårdande skötsel', value: 'Naturvårdande skötsel (NS)' }]">
          </rask-radiobutton-group>
        </div>
      </div>
      <div class="row">
        <div class="col ps-0">
          <rask-textarea label="Kompletterande information (skickas ej till avverkningsdirektivet)"
            class="col-12"
            placeholder='Särskilda råd från myndigheter eller särskild information om miljövärdena, t ex: "Naturvärdesträd finns samlade i nordöstra hörnet av beståndet"'
          [rows]="5" [maxlength]="500" formControlName="kompletterandeInformation"></rask-textarea>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col ps-0">
          <rask-radiobutton-group label="Naturvärdesbedömning gjord på *"
            [buttons]="[{ key: true, value: 'Barmark' }, { key: false, value: 'Snö' }]"
          formControlName="bedomningSno"></rask-radiobutton-group>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col ps-0">
          <rask-checkbox [flexResize]="true" label="Naturvärdesbedömning utförd"
            [raskDisabledControl]="!canSave()"
            formControlName="naturvardesbedomningUtford"
            (ngModelChange)="utfordChanged($event)"
            text="Jag har bedömt samtliga miljövärden på åtgärden enligt instruktion för naturvärdesbedömning virkesköp *">
          </rask-checkbox>
        </div>
      </div>
    </div>
  }
</div>